module.exports = __webpack_public_path__ + "static/img/bcg_festivals.fdda8e14.png";